<template>
  <div>
    <DomainsLayout>
      <PageHeader slot="page-header" :title="$t('tolling.header_rules')" />
      <div slot="page-header" class="rules-actions-container">
        <VariantSelector :variants="getVariants" @variantSelection="updateVariant" />
        <ObsoleteSelector @obsoleteSelection="updateObsolete" />
      </div>
      <DomainsListToolbar
        v-if="viewList"
        slot="domains-list-toolbar"
      />
      <DomainsListContent
        v-if="viewList"
        slot="domains-list"
        :variant="variantSelected.id"
        :showObsolete="showObsolete"
      />
    </DomainsLayout>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { Variant } from 'ctp-toll-domain';
import PageHeader from '@/components/common/PageHeader/PageHeader.vue';
import { store as tollStore } from '@/store/modules/tollDomain/types';
import DomainsLayout from './components/DomainsLayout/DomainsLayout.vue';
import DomainsListContent from './components/DomainsListContent/DomainsListContent.vue';
import DomainsListToolbar from './components/DomainsListToolbar/DomainsListToolbar.vue';
import ObsoleteSelector from './components/ObsoleteSelector/ObsoleteSelector.vue';
import VariantSelector from './components/VariantSelector/VariantSelector.vue';

@Component({
  components: {
    PageHeader,
    DomainsLayout,
    DomainsListToolbar,
    DomainsListContent,
    ObsoleteSelector,
    VariantSelector
  }
})
export default class Domains extends Vue {
  @tollStore.Getter
  private getVariants: Variant[];

  private viewList = true;

  private variantSelected = {};

  private showObsolete = false;

  private updateVariant(variant: Variant) {
    this.variantSelected = variant;
  }

  private updateObsolete(obsolete: boolean) {
    this.showObsolete = obsolete;
  }
}
</script>
<style lang="scss" scoped>
@import './styles/domains.scss';
</style>
